import React, {useState} from 'react';
import './../styles.css';
import MapSketch from './mapSketch';
import MapInfoPanel from './mapInfoPanel';
import {useDispatch} from 'react-redux';
import {setPathRq} from './../../../actions/initiativeActions';

function MapComponent({jsonPaths}){
    
    const dispatch = useDispatch();
    const [itemOver, svitemOver] = useState({
        regionSelected:0,
        pathSelected:""
    });

    const overPath = (region) => {
        svitemOver({
            regionSelected:region.id,
            pathSelected:region.pathSelected
        });
    }

    const leavePath = () => {
        svitemOver({
            regionSelected:0,
            pathSelected:""
        });
    }

    const clickPath = (region) => {
        dispatch(setPathRq(region));
    }

    const mainConfig = {
        jsonPaths:jsonPaths,
        scale:5,
        overPath:(parent, path) => overPath(parent, path),
        leavePath:leavePath,
        clickPath:(region) => clickPath(region),
        colorPath:{
            primary:"#5e78a3",
            secondary:"#45a6dd",
            default:"#9edcf8"
        },
        padding:20
    };

    return (
        <div className="cont-map-component">
            {/*<div>{navigator.userAgent}</div>*/}
            <MapInfoPanel mainConfig={mainConfig} itemOver={itemOver}/>
            <MapSketch mainConfig={mainConfig} itemOver={itemOver}/>
        </div>
    )
}

export default MapComponent;